export default "__VITE_ASSET__CepS3chJ__"